export const Constants = {
  currentUser: 'currentUserTrendmultiAdmin',
}